const formatDefault = ({ value }) => (
    value === 1 ? 'Yes' : 'No'
);

export default formatDefault

